module.exports = __webpack_public_path__ + "img/升华三维.b9dddf2b.png";